import { Cover } from '../types/cover';

export interface CoverDetails {
  canHaveInterestedParties: boolean;
}

export const coverDetailsMap: Record<Cover, CoverDetails> = {
  [Cover.Liability]: {
    canHaveInterestedParties: false,
  },
  [Cover.BuildingAndContents]: {
    canHaveInterestedParties: true,
  },
  [Cover.BusinessInterruption]: {
    canHaveInterestedParties: true,
  },
  [Cover.PortableItems]: {
    canHaveInterestedParties: true,
  },
  [Cover.Theft]: {
    canHaveInterestedParties: true,
  },
  [Cover.Money]: {
    canHaveInterestedParties: true,
  },
  [Cover.Glass]: {
    canHaveInterestedParties: true,
  },
  [Cover.Breakdown]: {
    canHaveInterestedParties: true,
  },
  [Cover.TaxAudit]: {
    canHaveInterestedParties: false,
  },
};
